import { render, staticRenderFns } from "./Deal.vue?vue&type=template&id=0b4440aa&scoped=true&"
import script from "./Deal.vue?vue&type=script&lang=js&"
export * from "./Deal.vue?vue&type=script&lang=js&"
import style0 from "./Deal.vue?vue&type=style&index=0&id=0b4440aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4440aa",
  null
  
)

export default component.exports